var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 805.511,
    height: 82.202,
    viewBox: "0 0 805.511 82.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "id_101",
    d: "M260.884,78.649h-3.949l3.949,5.131-3.949-5.131h0c-154-.684-246.653-13.78-246.653-29.8S173.4,19.8,327.4,19.116v-.065l190.062-.627,187.575.627H721.1l-82.929,8.536c-9.793,1.008-9.793,2.656,0,3.664S658.8,28.594,668.6,27.586l129.795-9.163c5.06-.521,7.376-1.21,7.225-1.9.176-.687-2.165-1.376-7.225-1.9L668.6,5.467C658.8,4.459,647.967.8,638.173,1.8s-9.793,2.656,0,3.664l81.62,8.4H327.4c-1.485,0-2.744.062-4.154.088C143.367,14.861.117,30.113.117,48.85c0,19.32,73.056,34.93,260.767,34.93,3.4,0-3.4.01,0,0h0v.052l-.293-.052c13.847,0,2.492-2.472,2.492-3.9S256.948,78.645,260.884,78.649Z",
    transform: "translate(-0.117 -1.63)",
    fill: "#ececec",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/Arrow right.6d42c68ebafa03aa8f8ac502e49ef3e3.svg";
export { ForwardRef as ReactComponent };